export const HOME_SERVICES_TYPE =
  'Home services (plumbing, HVAC, roofing, etc.)';
export const OTHER_LOCAL_BUSINESS_TYPE =
  'Other local business (restaurant, dentist, auto shop, etc.)';
export const OTHER_CATEGORY = 'Other (please describe)';

export const TYPE_OPTIONS = [HOME_SERVICES_TYPE, OTHER_LOCAL_BUSINESS_TYPE];

export const HOME_SERVICES = [
  'Air Duct Cleaning',
  'Appliance Repair',
  'Artificial Turf Installation',
  'Bathroom Remodeling',
  'Cabinet Installation & Refinishing',
  'Carpet Cleaning',
  'Chimney Cleaning & Repair',
  'Concrete Contractor',
  'Deck & Patio Contractor',
  'Door Installation & Repair',
  'Drain Cleaning',
  'Dryer Vent Cleaning',
  'Electrician',
  'Fencing Contractor',
  'Flooring Contractor',
  'Foundation Repair',
  'Garage Door Repair & Installation',
  'General Contractor',
  'Generator Installation',
  'Gutter Installation & Cleaning',
  'Handyman',
  'Home Cleaning',
  'Home Inspection',
  'Home Remodeling',
  'Home Security Installation',
  'HVAC (Heating & Air Conditioning)',
  'Insulation Contractor',
  'Irrigation & Sprinkler Services',
  'Junk Removal',
  'Kitchen Remodeling',
  'Landscaping',
  'Lawn Care',
  'Locksmith',
  'Masonry Contractor',
  'Mold Remediation',
  'Moving Company',
  'Painting Contractor',
  'Paver Installation',
  'Pest Control',
  'Plumber',
  'Pool Cleaning & Maintenance',
  'Pool Construction & Remodeling',
  'Pressure Washing',
  'Roofing Contractor',
  'Septic Tank Services',
  'Siding Contractor',
  'Solar Panel Installation',
  'Tree Services',
  'Water Damage Restoration',
  'Water Filtration & Treatment',
  'Waterproofing (Basement & Foundation)',
  'Window Cleaning',
  'Window Installation & Replacement',
  OTHER_CATEGORY
];

export const OTHER_INDUSTRIES = [
  'Restaurant',
  'Cafe / Coffee Shop',
  'Bakery',
  'Dentist',
  'Doctor / Clinic',
  'Chiropractor',
  'Hair Salon',
  'Barber',
  'Spa / Massage',
  'Fitness / Gym',
  'Auto Repair',
  'Car Wash',
  OTHER_CATEGORY
];

const normalizeCategory = (category) =>
  String(category || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

const CATEGORY_ALIASES = {
  Electrician: ['electrical contractor'],
  'HVAC (Heating & Air Conditioning)': [
    'hvac',
    'hvac contractor',
    'heating contractor',
    'air conditioning contractor'
  ],
  'General Contractor': ['general contracting'],
  'Roofing Contractor': ['roofer'],
  Landscaping: ['landscape designer'],
  'Lawn Care': ['lawn care service'],
  'Home Cleaning': ['cleaning service', 'house cleaning service'],
  'Cafe / Coffee Shop': ['cafe', 'coffee shop'],
  'Doctor / Clinic': ['doctor', 'medical clinic', 'medical office'],
  Barber: ['barber shop'],
  'Spa / Massage': ['spa', 'massage therapist', 'massage spa'],
  'Fitness / Gym': ['gym', 'fitness center'],
  'Auto Repair': ['auto repair shop', 'car repair and maintenance']
};

export const getBusinessCategory = (category = '') => {
  const normalizedCategory = normalizeCategory(category);
  if (!normalizedCategory) return undefined;

  const categories = [
    ...HOME_SERVICES.map((label) => ({
      label,
      type: HOME_SERVICES_TYPE
    })),
    ...OTHER_INDUSTRIES.map((label) => ({
      label,
      type: OTHER_LOCAL_BUSINESS_TYPE
    }))
  ];
  const matchingCategory = categories.find(
    ({ label }) =>
      label !== OTHER_CATEGORY &&
      (normalizeCategory(label) === normalizedCategory ||
        (CATEGORY_ALIASES[label] || []).some(
          (alias) => normalizeCategory(alias) === normalizedCategory
        ))
  );

  if (matchingCategory) {
    return {
      type: matchingCategory.type,
      choice: matchingCategory.label,
      other: ''
    };
  }

  if (
    normalizedCategory === 'other' ||
    normalizedCategory === 'other please describe'
  ) {
    return {
      type: OTHER_LOCAL_BUSINESS_TYPE,
      choice: OTHER_CATEGORY,
      other: ''
    };
  }

  return {
    type: OTHER_LOCAL_BUSINESS_TYPE,
    choice: OTHER_CATEGORY,
    other: category
  };
};

export const getBusinessCategoryOptions = (type) =>
  type === HOME_SERVICES_TYPE
    ? HOME_SERVICES
    : type === OTHER_LOCAL_BUSINESS_TYPE
    ? OTHER_INDUSTRIES
    : [];

export const getIndustryValue = (category, other = '') =>
  category === OTHER_CATEGORY
    ? String(other || '').trim()
    : String(category || '').trim();
